export const TONESIM_TON_CONNECT_ACTIONS: {
  notifications: Array<'error'>;
  modals: 'all';
} = {
  notifications: ['error'],
  modals: 'all',
};
